export default "__VITE_ASSET__BwjM7a3$__"